import React, { MouseEventHandler } from "react";
import { Row, Col, Modal, Button } from "antd";
import styles from "./Modals.module.scss";
import { useWindowSize } from "../../../hooks/useWindowSize";

type Props = {
  visible: boolean;
  setVisibility: Function;
  handleUseDifferentCard: MouseEventHandler<HTMLElement>;
  last4Digits: string;
};

const CreditCardErrorModal: React.FC<Props> = ({
  visible,
  setVisibility,
  handleUseDifferentCard,
  last4Digits,
}) => {
  const handleCancel = () => setVisibility(false);

  const { width } = useWindowSize();

  return (
    <Modal
      visible={visible}
      className={styles.errorCCModalContainer}
      centered={width < 992}
      width={width < 992 ? "unset" : "500px"}
      footer={
        <Row justify="center" gutter={[15, 10]}>
          <Col>
            <Button className={styles.modalCancelBtn} onClick={handleCancel}>
              Cancel
            </Button>
          </Col>
          <Col>
            <Button
              className={styles.modalUseDiffBtn}
              onClick={handleUseDifferentCard}
            >
              Use a Different Card
            </Button>
          </Col>
        </Row>
      }
    >
      <Row justify="center">
        <Col className={styles.modalTitle}>Error Processing Credit Card</Col>
      </Row>
      <Row justify="center" className={styles.modalBody}>
        <Col>
          An error occurred while processing your saved credit card (ending
          in&nbsp;{last4Digits}).
        </Col>
      </Row>
    </Modal>
  );
};

export default CreditCardErrorModal;
